<template>
  <div class="gradient-text-container">
    <div class="gradient-text-content">
      <span class="animate-gradient" :style="gradientStyle">
        <slot>{{ text }}</slot>
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  text: {
    type: String,
    default: '',
  },
  colors: {
    type: Array,
    default: () => ['#bd003c', '#d60044', '#ffffff', '#d60044', '#bd003c'],
  },
  animationSpeed: {
    type: Number,
    default: 8,
  },
  direction: {
    type: String,
    default: 'horizontal',
  },
});

const gradientStyle = computed(() => {
  const gradientColors = props.colors.join(', ');
  let angle = '90deg';

  if (props.direction === 'vertical') angle = '180deg';
  if (props.direction === 'diagonal') angle = '135deg';

  return {
    backgroundImage: `linear-gradient(${angle}, ${gradientColors})`,
    backgroundSize: '300% 100%',
    animationDuration: `${props.animationSpeed}s`,
  };
});
</script>

<style lang="scss" scoped>
.gradient-text-container {
  display: inline-flex;
  position: relative;
  max-width: fit-content;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.gradient-text-content {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background: inherit;
  border-radius: inherit;
}

.animate-gradient {
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  animation: gradient-animation linear infinite;

  // Ensure it inherits parent typography.
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;

  // This ensures that nested spans (from CKEditor) don't override the transparency.
  :deep(span) {
    color: inherit !important;
    -webkit-text-fill-color: inherit !important;
  }
}

@keyframes gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
